import styled, { css } from "styled-components";
import Title from "common/Typography/Title";
import { onboardingStyles } from "@shared/features/onboarding/styles";
import { LARGE_MOBILE } from "common/constants";
import { hexToRGB } from "@shared/utils/misc";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens";

export const PrimaryTitle = styled(Title)<{ $isMobile: boolean }>`
  ${onboardingStyles.primaryTitle};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        ${newLookType.pageTitle};
        color: ${p.theme.colors.titleColor};
        margin: 0 0 24px;
        text-align: inherit;
        text-wrap: balance;
        /* Phones: the title leads the page under the small brand header. */
        @media (max-width: ${LARGE_MOBILE}) {
          font-size: 22px;
          line-height: 28px;
          letter-spacing: -0.015em;
        }
      }
    `}
`;

export const Wrapper = styled.div<{ $isMobile: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${(p) =>
    p.$isMobile &&
    `
  padding-bottom: 24px;
  `}
  ${(p) =>
    p.theme.isNewLook &&
    css`
      /* A calm single column, left-aligned like the sign-in form. */
      align-items: stretch;
      text-align: start;
      padding-bottom: 0;
    `}
`;

// New look only: supporting copy right under a title (the title keeps its
// 24px gap to the form; this pulls the copy up to 4px under it).
export const AuthDescription = styled.p`
  margin: -20px 0 24px;
  ${newLookType.body};
  color: ${(p) => p.theme.colors.secondaryText};
  overflow-wrap: anywhere;
  @media (max-width: ${LARGE_MOBILE}) {
    margin-top: -18px;
    font-size: 15px;
    line-height: 22px;
  }
`;

// New look only: a form-level error (or success), inline above the action
// it belongs to.
export const AuthInlineMessage = styled.div<{ $type?: "error" | "success" }>`
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  margin: 0 0 16px;
  padding: 10px 12px;
  border-radius: ${(p) => p.theme.radii.control}px;
  border: 1px solid
    ${(p) =>
      hexToRGB(
        p.$type === "success"
          ? getNewLookTokens(p.theme).up
          : getNewLookTokens(p.theme).down,
        0.3
      )};
  background: ${(p) =>
    hexToRGB(
      p.$type === "success"
        ? getNewLookTokens(p.theme).up
        : getNewLookTokens(p.theme).down,
      p.theme.isDarkMode ? 0.1 : 0.05
    )};
  ${newLookType.body};
  color: ${(p) => getNewLookTokens(p.theme).ink};
  text-align: start;
  svg {
    margin-top: 2px;
    color: ${(p) =>
      p.$type === "success"
        ? getNewLookTokens(p.theme).up
        : getNewLookTokens(p.theme).down};
  }
`;

// New look only: the line icon that heads a verification step.
export const AuthIcon = styled.span`
  display: inline-grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin-bottom: 20px;
  border-radius: 12px;
  background: ${(p) => p.theme.colors.lightBlue};
  color: ${(p) => p.theme.colors.primaryBlue};
  svg {
    display: block;
  }
`;
